/*
  移动端menu按钮点击变为close动画
  status: menu按钮开合状态(传入父组件中)
  headerOpen: 父组件其它操作导致menu状态改变(父组件传回)
*/
<template>
  <div class="mtoc-wrapper" @click.stop="statusChange">
    <div class="mtoc-main">
      <span
        class="mtoc-item"
        v-for="(item, index) in 3"
        :key="index"
        :class="{'status-close': status, 'status-fixed': headerFixed}" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    headerOpen: {
      type: Boolean
    },
    headerFixed: {
      type: Boolean
    }
  },
  data() {
    return {
      status: false
    };
  },
  methods: {
    statusChange() {
      this.status = !this.status;
      this.$emit('openMenu', this.status);
    }
  },
  watch: {
    'headerOpen': function() {
      this.status = this.headerOpen;
    }
  }
};
</script>

<style scoped lang="stylus">
.mtoc-wrapper
  cursor: pointer
  .mtoc-main
    display: inline-block;
    float: left;
    vertical-align: middle;
    .mtoc-item
      display: block;
      padding-top: 3px;
      padding-bottom: 3px;
      transition: all .4s ease;
      &:before
        content: '';
        display: block;
        height: 2px;
        width: 22px;
        background-color: #f1f1f1;
        border-top-right-radius: 2px;
        border-bottom-left-radius: 2px;
    .status-fixed
      transition: all .4s ease;
      &:before
        background-color: rgba(0, 0, 0, 1);
    .status-close
      transition: all .4s ease;
      &:before
        background-color: rgba(0, 0, 0, 1);
      &:nth-child(2)
        opacity: 0;
      &:nth-child(1)
        transform: translateY(8px);
        &:before
          transform: rotate(45deg);
      &:nth-child(3)
        transform: translateY(-8px);
        &:before
          transform: rotate(-45deg);

</style>



// WEBPACK FOOTER //
// src/components/menuToClose/mtoc.vue